// import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import {
  mdiAccount,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCircleMedium,
  mdiCircleSmall,
  mdiClose,
  mdiWrench,
  mdiSend,
  mdiLockOpenVariant,
  mdiLock,
  mdiMagnify,
  mdiAccountOff,
  mdiHandBackRightOff,
  mdiSync,
  mdiHandshake,
  mdiWeatherSunny,
  mdiWeatherNight,
  mdiCheck,
  mdiPin,
  mdiMessage,
  mdiAccountTie,
  mdiChartArc,
  mdiCellphoneBasic,
  mdiScriptTextOutline,
  mdiServerNetwork,
  mdiMessageCheck,
  mdiMessageOff,
  mdiForum,
  mdiAccountMultipleCheck,
  mdiAccountMultipleRemove,
  mdiPhonePlus,
  mdiAccountMultiple,
  mdiPhoneRemove,
  mdiCircle,
  mdiChartBoxOutline,
  mdiDevices,
  mdiEye,
  mdiEyeOff,
  mdiMessageAlertOutline,
  mdiPinOutline,
  mdiPhone,
  mdiPhoneHangup,
  mdiPhoneInTalk,
  mdiVideoOutline,
  mdiDoctor,
  mdiVolumeHigh,
  mdiMicrophoneOff,
  mdiMicrophone,
  mdiAccountVoice,
  mdiClockOutline,
  mdiVolumePlus,
  mdiVolumeMinus,
  mdiVolumeMedium,
  mdiVolumeOff,
  mdiWaveform,
  mdiInformationOutline
} from '@mdi/js'

// import { aliases, fa } from 'vuetify/iconsets/fa'

/** @description config icon sets  for vuetify */

/**  to set icons
 *   @constant
 *   @type {string}
 *   @default mdi
 *  **/
const defaultIconSet = 'mdi'
export default {
  defaultSet: defaultIconSet, // This is already the default value - only for display purposes,
  aliases: {
    ...aliases,
    account: mdiAccount,
    magnify: mdiMagnify,
    lock: mdiLock,
    accountOf: mdiAccountOff,
    lockOpen: mdiLockOpenVariant,
    handOf: mdiHandBackRightOff,
    refresh: mdiSync,
    close: mdiClose,
    mdiWrench: mdiWrench,
    handShake: mdiHandshake,
    mdiSend: mdiSend,
    mdiCheck: mdiCheck,
    mdiPin: mdiPin,
    mdiWeatherSunny: mdiWeatherSunny,
    mdiWeatherNight: mdiWeatherNight,
    chevronLeft: mdiChevronLeft,
    chevronRight: mdiChevronRight,
    circleSmall: mdiCircleSmall,
    circleMedium: mdiCircleMedium,
    mdiMessage: mdiMessage,
    mdiAccountTie: mdiAccountTie,
    mdiChartArc: mdiChartArc,
    mdiCellphoneBasic: mdiCellphoneBasic,
    mdiScriptTextOutline: mdiScriptTextOutline,
    mdiServerNetwork: mdiServerNetwork,
    mdiMessageCheck: mdiMessageCheck,
    mdiMessageOff: mdiMessageOff,
    mdiForum: mdiForum,
    mdiAccountMultipleCheck: mdiAccountMultipleCheck,
    mdiAccountMultipleRemove: mdiAccountMultipleRemove,
    mdiPhonePlus: mdiPhonePlus,
    mdiAccountMultiple: mdiAccountMultiple,
    mdiPhoneRemove: mdiPhoneRemove,
    mdiCircle: mdiCircle,
    mdiChartBoxOutline: mdiChartBoxOutline,
    mdiDevices: mdiDevices,
    mdiEye: mdiEye,
    mdiEyeOff: mdiEyeOff,
    mdiMessageAlertOutline: mdiMessageAlertOutline,
    mdiPinOutline: mdiPinOutline,
    mdiPhone: mdiPhone,
    mdiPhoneHangup: mdiPhoneHangup,
    mdiPhoneInTalk: mdiPhoneInTalk,
    mdiVideoOutline: mdiVideoOutline,
    mdiDoctor: mdiDoctor,
    mdiVolumeHigh: mdiVolumeHigh,
    mdiVolumePlus: mdiVolumePlus,
    mdiVolumeMinus: mdiVolumeMinus,
    mdiVolumeOff: mdiVolumeOff,
    mdiMicrophoneOff: mdiMicrophoneOff,
    mdiMicrophone: mdiMicrophone,
    mdiAccountVoice: mdiAccountVoice,
    mdiClockOutline: mdiClockOutline,
    mdiVolumeMedium: mdiVolumeMedium,
    mdiWaveform: mdiWaveform,
    mdiInformationOutline: mdiInformationOutline
  },

  // aliases,
  sets: {
    mdi //material icon sets
    // fa, //font awesome
  }
}
